import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory } from "react-router";
import { smartAlert } from "../lib/confirm-alert";
import { agent } from "../agent";
import TransitionCancel from "../pages/TransitionCancel";
import { URL_PATHS } from "../routes";
import { AppState } from "../store";
import { myDataActions } from "../store/myData";

interface TransitionCancelState {
    isLoading: boolean;
}

const initialState: TransitionCancelState = {
    isLoading: false
};

const TransitionCancelContainer = () => {
    const [state, setState] = useState(initialState);
    const history = useHistory();
    const dispatch = useDispatch();
    const payment = useSelector((state: AppState) => state.payment);

    async function onTransitionCancel(): Promise<void> {
        setState({ ...state, isLoading: true });
        try {
            await agent.putCancelTransferToCard();
            dispatch(myDataActions.myDataShouldLoadSet(true));
            setState({ ...state, isLoading: false });
            history.push(URL_PATHS.transitionCancelFinish());
        } catch (e) {
            setState({ ...state, isLoading: false });
            console.error(e);
            await smartAlert(
                "クレジットカード決済への移行のキャンセル処理に失敗しました。"
            );
        }
    }

    if (payment.status.cardPaymentTransitionApplicationDate == null) {
        return <Redirect to={URL_PATHS.myPage()} />;
    }

    return (
        <TransitionCancel
            onTransitionCancel={onTransitionCancel}
            isLoading={state.isLoading}
        />
    );
};

export default TransitionCancelContainer;
